// extracted by mini-css-extract-plugin
export var cardContainer = "_ol-0";
export var cardHeader = "_ol-2";
export var collapsedState = "_ol-3";
export var dragHandle = "_ol-5";
export var dragHandleIcon = "_ol-6";
export var dragging = "_ol-1";
export var titleArea = "_ol-4";